import { loadApplicationIfSupported } from './bootstrap-application.js'

void loadApplicationIfSupported(document.getElementById('root'), () => import('./main.js'))
